import {
  HOME_GET_CLOSE_OUT_REPORT_BEGIN,
  HOME_GET_CLOSE_OUT_REPORT_SUCCESS,
  HOME_GET_CLOSE_OUT_REPORT_FAILURE,
  HOME_GET_CLOSE_OUT_REPORT_DISMISS_ERROR,
} from './constants';


import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';

import axios from 'axios';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getCloseOutReport(project_id,args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_GET_CLOSE_OUT_REPORT_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(
        SERVER_PATH + '/close_out/reportPDF/' + project_id + '/close_out.pdf',
        AXIOS_CONFIG(1),
        {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
                // 'Accept': 'application/pdf'
            }
        },
      );
      doRequest.then(
        (res) => {
           var downloadLink      = document.createElement('a');
          // downloadLink.target   = '_blank';
          downloadLink.download = 'close_out.pdf';

          // convert downloaded data to a Blob
          var blob = new Blob([res.data], { type: 'application/pdf' });

          // create an object URL from the Blob
          var URL = window.URL || window.webkitURL;
          var downloadUrl = URL.createObjectURL(blob);

          // set object URL as the anchor's href
          downloadLink.href = downloadUrl;

          // append the anchor to document body
          document.body.append(downloadLink);

          // fire a click event on the anchor
          downloadLink.click();

          // cleanup: remove element and revoke object URL
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(downloadUrl);
          dispatch({
            type: HOME_GET_CLOSE_OUT_REPORT_SUCCESS,
            data: res,
          });
          resolve(true);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_GET_CLOSE_OUT_REPORT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
      // doRequest.then(
      //   (res) => {
      //     dispatch({
      //       type: HOME_GET_CLOSE_OUT_REPORT_SUCCESS,
      //       data: res,
      //     });
      //     resolve(res);
      //   },
      //   // Use rejectHandler as the second argument so that render errors won't be caught.
      //   (err) => {
      //     dispatch({
      //       type: HOME_GET_CLOSE_OUT_REPORT_FAILURE,
      //       data: { error: err },
      //     });
      //     reject(err);
      //   },
      // );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetCloseOutReportError() {
  return {
    type: HOME_GET_CLOSE_OUT_REPORT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_GET_CLOSE_OUT_REPORT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getCloseOutReportPending: true,
        getCloseOutReportError: null,
      };

    case HOME_GET_CLOSE_OUT_REPORT_SUCCESS:
      // The request is success
      return {
        ...state,
        getCloseOutReportPending: false,
        getCloseOutReportError: null,
      };

    case HOME_GET_CLOSE_OUT_REPORT_FAILURE:
      // The request is failed
      return {
        ...state,
        getCloseOutReportPending: false,
        getCloseOutReportError: action.data.error,
      };

    case HOME_GET_CLOSE_OUT_REPORT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getCloseOutReportError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/getCloseOutReport.js